import { sniff } from "./signatures";

// A file arrives as bytes and stays bytes: nothing here decodes, re-encodes or re-saves anything, so whatever is
// downloaded at the end is what was read plus exactly the edits somebody made.

export interface Loaded {
  name: string;
  type: string;
  size: number;
  modified: number | null;
  bytes: Uint8Array;
  // What the first bytes say the file is, which is the one thing a hex dump cannot tell somebody at a glance.
  kind: string | null;
}

// The editor's document is the dump itself — three characters a byte, held beside the bytes and beside the copy an
// edit makes of them — so what a tab holds is about four times the file. Measured, that is 39 MiB of heap and two
// seconds to lay out at this ceiling, and neither is worth doubling for a file somebody wanted to read a byte of.
export const MAX_BYTES = 8 * 1024 * 1024;

export async function load(file: File): Promise<Loaded> {
  if (file.size > MAX_BYTES) throw new Error(`That file is larger than the ${MAX_BYTES / 1024 / 1024} MB this reads.`);
  const bytes = new Uint8Array(await file.arrayBuffer());
  return {
    name: file.name || "file.bin",
    // A download that names no type is one the browser guesses at, and a guess is what the extension already is.
    type: file.type || "application/octet-stream",
    size: bytes.length,
    modified: file.lastModified || null,
    bytes,
    kind: sniff(bytes),
  };
}

export function message(error: unknown): string {
  return error instanceof Error ? error.message : String(error);
}
